import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Vestiging } from '../models/vestiging.model';
import { Discipline } from '../models/discipline.model';
import { MediaService } from './media.service';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class TeamService {

  constructor(private http:HttpClient, private mediaService:MediaService) { }

  getTeam() {
    return this.http.get<any>(`${environment.apiBaseUrl}/teamleden?populate=*&sort[0]=order&sort[1]=achternaam`);
  }

  getTeamlid(id:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/teamleden?filters[id][$eq]=${id}&populate=*`);
  }

  getTeamForVestiging(vid:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/teamleden?filters[vestigingen][id][$eq]=${vid}&populate=*&sort[0]=order&sort[1]=achternaam`);
  }

  populateTeamlid(data:any) {
    let member = data;
    member.id = data.id;
    member.foto = this.mediaService.getMediaItemUrl(member.foto);
    member.vestigingen = this.parse(member.vestigingen);
    member.disciplines = this.parse(member.disciplines);
    member.specialisaties = this.parse(member.specialisaties);

    return member;
  }

  parse(coll:any) {
    let list:any = [];
    for(let e of coll) {
      let obj = e;
      obj.id = e.id;
      list.push(obj);
    }
    return list;
  }
}
